import { useCart } from '@/entities/cart'

import { CartInfoSchemaScript } from '@/shared/integrations/mindBox/scripts/cart-info-schema-script'

export const CartInfoSchema = () => {
	const { price, products } = useCart()

	if (!price || !products?.length) return null

	return <CartInfoSchemaScript cartItems={products} totalPrice={price} />
}
